// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1ppbA","right":"Footer_right__1ch0G","buttons":"Footer_buttons__2EZOv"};